import React from 'react';

import { IndustryEnum } from '../../../../graphql/gen/types';
import { IndustryEnumData } from '../../../../utils/enumData';
import { PlexSelect } from '../../../shared/primitives/PlexSelect';
import { PlexTextField } from '../../../shared/primitives/PlexTextField';
import { EditableAvatar } from '../EditableAvatar';
import { SettingsContent } from '../SettingsContent';
import { useAccountStyles } from './styles';
import { SettingsPageProps } from './types';

export const AccountSettings = ({
  savedSettings,
  unsavedSettings,
  loadingMutation,
  onChange,
  onSave,
  onCancel,
  updateDisabled,
}: SettingsPageProps): React.ReactElement | null => {
  const classes = useAccountStyles();
  const domain = savedSettings.domain;
  if (!domain) {
    return null;
  }

  return (
    <SettingsContent
      title={'Account Settings'}
      onSave={onSave}
      onCancel={onCancel}
      updateDisabled={updateDisabled}
      loadingMutation={loadingMutation}
    >
      <EditableAvatar
        alt={'avatar'}
        picture={unsavedSettings.domain?.picture || domain.picture || ''}
        loading={loadingMutation}
        onUploadComplete={(file: string): void => onChange({ domain: { picture: file } })}
      />
      <PlexTextField
        id={'account-settings-org-name'}
        label={'Org Name'}
        className={classes.fullWidth}
        value={unsavedSettings.domain?.orgName || domain.orgName}
        handleChange={(value): void =>
          onChange({
            domain: {
              orgName: value,
            },
          })
        }
      />
      <PlexTextField
        id={'account-settings-domain'}
        label={'Domain'}
        className={classes.borderRight}
        disabled
        value={domain.url}
      />
      <PlexSelect
        label={'Industry'}
        options={IndustryEnumData}
        value={unsavedSettings.domain?.industry || domain.industry || IndustryEnum.Technology}
        handleChange={(value): void =>
          onChange({
            domain: {
              industry: value as IndustryEnum,
            },
          })
        }
        className={classes.halfWidth}
      />
      <PlexTextField
        id={'account-settings-email'}
        label={'Account Email'}
        className={classes.fullWidth}
        value={unsavedSettings.domain?.email || domain.email}
        handleChange={(value): void =>
          onChange({
            domain: {
              email: value,
            },
          })
        }
      />
      <PlexTextField
        id={'account-settings-address'}
        label={'Account Address'}
        className={classes.fullWidth}
        value={unsavedSettings.domain?.address || domain.address}
        handleChange={(value): void => onChange({ domain: { address: value } })}
      />
    </SettingsContent>
  );
};
